import React from 'react'
import { Link } from 'react-router-dom'
import './services.css'

const services = [
  {
    title: 'Chat',
    description: 'Get instant astrological guidance',
    cls: 'chat-service',
    emoji: '💬',
    link: '/astrologer'
  },
  {
    title: 'Astroscope Store',
    description: 'Explore spiritual products',
    cls: 'store-service',
    emoji: '🏪',
    link: '/categories'
  },
  {
    title: "Today's Horoscope",
    description: 'Daily predictions for all signs',
    cls: 'horoscope-service',
    emoji: '☀️',
    link: '/horoscope/aries'
  },
  {
    title: 'Free Kundli',
    description: 'Generate your birth chart',
    cls: 'kundli-service',
    emoji: '🕉️',
    link: '/free-kundli'
  }
]

const TopServicesSection = () => (
  <section className="top-services-section as_padderTop80 as_padderBottom80">
    <div className="container">
      <div className="row">
        <div className="col-12 text-center">
          <h1 className="as_heading as_heading_center">Our Top Services</h1>
        </div>
      </div>
      <div className="row justify-content-center">
        {services.map((srv, idx) => (
          <div key={idx} className="col-lg-3 col-md-6 col-sm-6 col-12 mb-4 d-flex">
            <Link to={srv.link} className="service-card d-block text-center w-100 p-4">
              <span className={`service-graphic ${srv.cls}`} aria-hidden="true">
                 <span className="graphic-inner">{srv.emoji}</span>
              </span>
              <h5 className="mb-2">{srv.title}</h5>
              {/* <p className="m-0 text-muted">{srv.description}</p> */}
            </Link>
          </div>
        ))}
      </div>
    </div>
  </section>
)

export default TopServicesSection 